import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';


import './components/Common/Common.css'
import './components/Common/CorrespondenceManager.css'
import './components/Home/FormCard.css'
import './components/Code/CodeEntry.css';
import './bootoast/bootoast.css';
import './components/Analytics/Analytics.css';

import './components/DevelopmentLogin/DevOnly.css';


const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

ReactDOM.render(
  <BrowserRouter basename={baseUrl}>
    <App />
  </BrowserRouter>,
  rootElement);

//registerServiceWorker();
